import { z, ZodType } from 'zod'

import { MissionTypeEnum } from '../../../lib/types/enums/mission/mission-type.enum'
import { MissionInput } from '../../../lib/types/models/mission/mission-input'
import {
  createDateStringSchema,
  createTimeSchema
} from '../../../lib/utils/validations/date.validation'
import { createEnumSchema } from '../../../lib/utils/validations/enum-validation'
import {
  createNumberArraySchema,
  createNumberSchema
} from '../../../lib/utils/validations/int-array-validation'
import { createStringSchema } from '../../../lib/utils/validations/string-validation'

export const missionFormSchema: ZodType<MissionInput> = z.object({
  type: createEnumSchema({ fieldName: 'Type', enumType: MissionTypeEnum }),
  requiredNumberOfStaff: createNumberSchema("Nbre d'AAT requis"),
  description: createStringSchema('Description', { nullish: true }),
  date: createDateStringSchema({ inputName: 'Date' }).optional(),
  appointmentTime: createTimeSchema({ inputName: 'Heure de RDV' }).optional(),
  meetingPlaceId: createNumberSchema('Lieu de RDV', { nullish: true }),
  tripBookingIds: createNumberArraySchema('Trip Bookings', { nullish: true }),
  labelId: createNumberSchema('libellé')
})
